<template>
  <div class="component-datepicker">
    <template v-if="inline">
      <calendar
        v-model="selected_date_obj"
        :display="display"
        :inline="inline"
        :format="format"
        :width="width"
        :height="height"
        :effective_dates_period="effective_dates_period"
        :disable_dates="disable_dates"
        :holidays="holidays_list"
        :schedules="schedules"
        @update_date_obj="update_date_obj"
        @update_format="update_format"
        @changed_month="changed_month"
      />
    </template>
    <template v-else>
      <div class="calendar-input-container">
        <div
          :class="{ 'components-selected' : display }"
          class="calendar-value"
          @click="focus_in"
        >{{ selected_date }}</div>
        <div
          v-if="display"
          class="calendar-cover"
          @click="focus_out"/>
        <calendar
          v-model = "selected_date_obj"
          :display.sync="display"
          :inline="inline"
          :format="format"
          :width="width"
          :height="height"
          :effective_dates_period="effective_dates_period"
          :disable_dates="disable_dates"
          :holidays="holidays_list"
          :schedules="schedules"
          @update_date_obj="update_date_obj"
          @update_format="update_format"
          @changed_month="changed_month"
        />
      </div>
    </template>
  </div>
</template>

<script>
// import Vue from 'vue';
import Calendar from './calendar.vue';

export default {
  name: 'Datepicker',
  // ===========================================================================
  // Components
  // ===========================================================================
  components: {
    Calendar
  },
  // ===========================================================================
  // Props
  // ===========================================================================
  props: {
    value: {
      type: [String, Date],
      required: false,
      default: () => {
        return new Date();
      }
    },
    // true: カレンダー表示 false:text inputからカレンダーポップアップ表示
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    // フォーマット
    format: {
      type: String,
      required: false,
      default: 'YYYY/MM/DD'
    },
    // カレンダーのwidth
    width: {
      type: Number,
      required: false,
      default: null
    },
    // カレンダーのheight
    height: {
      type: Number,
      required: false,
      default: null
    },
    // カレンダーの選択有効期間
    effective_dates_period: {
      type: Object,
      required: false,
      default: () => {
        const obj = new Object();
        // dateオブジェクト,または文字列(YYYYMMDD)
        obj.from = null;
        obj.to = null;
        return obj;
      }
    },
    // カレンダーの無効日付
    disable_dates: {
      type: Array,
      required: false,
      default: () => {
        // dateオブジェクト,または文字列(YYYYMMDD)
        return new Array();
      }
    },
    // 祝日（指定した日が赤くなる）
    holidays: {
      type: Array,
      required: false,
      default: () => {
        // dateオブジェクト,または文字列(YYYYMMDD)
        return new Array();
      }
    },
    // 予定
    schedules: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    }
  },
  // ===========================================================================
  // Data
  // ===========================================================================
  data () {
    return {
      display: false,
      selected_date: ''
    };
  },
  // ===========================================================================
  // Computed
  // ===========================================================================
  computed: {
    selected_date_obj () {
      let value = this.value;
      let year, month, date;
      if (typeof value === 'string') {
        if (value === '') {
          return '';
        }
        year = value.substr(0, 4);
        month = value.substr(4, 2);
        date = value.substr(6, 2);
        return new Date(year, month -1, date);
      } else {
        return value;
      }
    },
    holidays_list () {
      let arr = this.holidays;
      let i, len = arr.length;
      let result = [];
      for (i = 0; i < len; i++) {
        result.push(arr[i].day.replace(/-/g, ''));
      }
      return result;
    }
  },
  // ===========================================================================
  // Methods
  // ===========================================================================
  methods: {
    focus_in () {
      this.display = true;
    },
    focus_out () {
      this.display = false;
    },
    update_date_obj (date_obj) {
      if (typeof this.value === 'string') {
        if (date_obj === '') {
          return '';
        }
        let year = date_obj.getFullYear();
        let month = this.zero_pad(date_obj.getMonth() + 1);
        let date = this.zero_pad(date_obj.getDate());

        this.$emit('input', String(year) + String(month) + String(date));
      } else {
        this.$emit('input', date_obj);
      }
    },
    update_format (date) {
      this.selected_date = date;
      this.$emit('selected', date);
    },
    changed_month (ym) {
      this.$emit('changed_month', ym);
    },
    zero_pad (num) {
      return ('00' + String(num)).slice(-2);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.component-datepicker {
  .calendar-input-container {
    height: 100%;
  }

  .calendar-cover {
    position: fixed;
    z-index: 8000;
    top: 0;
    left: 0;
    // background-color: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 100%;
  }

  .calendar-value {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #7b7b7b;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    cursor: pointer;
  }

  .components-selected {
    border-color: #2e98f3;
  }
}
</style>
